import Joi from 'joi';

type Result<T> = [boolean, Record<keyof T, string>];

const useValidation = <T>(form: T, validator: Joi.ObjectSchema<T>): Result<T> => {
	const { error } = validator.validate(form, { abortEarly: false });

	const errorObject =
		error?.details.reduce((acc: any, x: any) => {
			acc[`${x.path}`] = x.message;
			return acc;
		}, {}) || {};

	return [!error, errorObject as Record<keyof T, string>];
};

export default useValidation;
